/// <amd-module name="SuiteCommerce.GiftCertificate.LandingPage.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.GiftCertificate.LandingPage.View", ["require", "exports", "Backbone", "SuiteCommerce.GiftCertificate.LandingPage.Configuration", "SuiteCommerce.GiftCertificate.ValueCheck.Model", "SuiteCommerce.GiftCertificate.ValueCheck.View", "SuiteCommerce.GiftCertificate.Common.FeedbackMessageManager", "giftcertificate_landing_page.tpl", "SuiteCommerce.GiftCertificate.GiftCertificateMessage.View", "SuiteCommerce.GiftCertificate.GiftCertificateMessage.Model"], function (require, exports, Backbone_1, LandingPage_Configuration_1, ValueCheck_Model_1, ValueCheck_View_1, FeedbackMessageManager_1, template, GiftCertificate_Message_View_1, GiftCertificate_Message_Model_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.LandingPageView = void 0;
    var LandingPageView = /** @class */ (function (_super) {
        __extends(LandingPageView, _super);
        function LandingPageView(options) {
            var _this = _super.call(this, options) || this;
            _this.type = options.type;
            _this.container = options.container;
            _this.template = template;
            _this.title = LandingPage_Configuration_1.LandingPageConfiguration.landingPageTitle;
            _this.updateBreadcrumbPages();
            return _this;
        }
        LandingPageView.prototype.updateBreadcrumbPages = function () {
            var pages = [
                {
                    text: LandingPage_Configuration_1.LandingPageConfiguration.landingPageTitle,
                    href: LandingPage_Configuration_1.LandingPageConfiguration.landingPageRoute,
                }
            ];
            this.getBreadcrumbPages = function () { return pages; };
        };
        Object.defineProperty(LandingPageView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    ValueCheckView: function () {
                        var valueCheckView = new ValueCheck_View_1.ValueCheckView({
                            model: new ValueCheck_Model_1.ValueCheckModel({}),
                            container: _this.container,
                            environment: ValueCheck_View_1.ExternalEnvironment.SHOPPING,
                            title: _this.title,
                        });
                        valueCheckView.on(FeedbackMessageManager_1.AddFeedbackMessageEvent, function (messageEvent) {
                            _this.showFeedbackMessage(messageEvent.type, messageEvent.message);
                        });
                        valueCheckView.on(FeedbackMessageManager_1.RemoveFeedbackMessageEvent, function () {
                            _this.clearFeedbackMessage();
                        });
                        return valueCheckView;
                    },
                };
            },
            enumerable: false,
            configurable: true
        });
        LandingPageView.prototype.getContext = function () {
            return {
                title: this.title,
            };
        };
        LandingPageView.prototype.showFeedbackMessage = function (type, message) {
            var placeholder = this.$('[data-view="GlobalMessagesView"]');
            var feedbackMessage = new GiftCertificate_Message_View_1.GiftCertificateMessageView({
                model: new GiftCertificate_Message_Model_1.GiftCertificateMessageModel({
                    message: message,
                    type: type,
                    closable: true,
                })
            });
            placeholder.empty();
            placeholder.append(feedbackMessage.render().$el.html());
        };
        LandingPageView.prototype.clearFeedbackMessage = function () {
            var placeholder = this.$('[data-view="GlobalMessagesView"]');
            placeholder.empty();
        };
        return LandingPageView;
    }(Backbone_1.View));
    exports.LandingPageView = LandingPageView;
});
